<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="6">
        <div class="d-flex" style="justify-content: space-around">
          <b-overlay
              :show="downloadDataLoading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
          >
            <b-button @click="downloadData" variant="outline-primary" size="sm" v-if="showDownloadButton"
                      :disabled="downloadDataLoading">
            <span v-if="!downloadDataLoading">
              <i class="bi bi-download"></i>
              Esporta
            </span>
              <span v-else>
              <i class="bi bi-hourglass-split"></i>
              Esportazione in corso...
            </span>
            </b-button>
          </b-overlay>
          <b-form-group v-if="showFilter" class="w-50">
            <ClearableInput v-model="internalFilter" variant="sm">
              <b-form-input
                  v-model="internalFilter"
                  placeholder="Filtra"
                  @focus="$event.target.select()"
                  size="sm"
                  class="w-100"
              />
            </ClearableInput>
          </b-form-group>
          <slot name="leftOfPaginator"></slot>
        </div>
      </b-col>
      <b-col cols="6">
        <b-row class="d-flex align-items-center">
          <b-col v-if="totalRows && totalRows > 10">
            <b-form-select
                size="sm"
                v-model="perPage"
                @change="setPerPage"
                :options="paginationOptions"
            ></b-form-select>
          </b-col>
          <b-col cols="10" v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-2 pagination"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <site-overlay
        :show="busy"
        id="table-b-overlay">
      <b-table
          :responsive="true"
          :items="items"
          :fields="fields"
          ref="table"
          :sortDesc="sortDesc"
          :sortBy="sortBy"
          @update:sortBy="sortBy = $event"
          @update:sortDesc="sortDesc = $event"
          :sortInternal="false"
          :noProviderSorting="false"
          :provider="() => items"
          :class="{ 'h-auto': autoHeight }"
          class="tabella-articoli"
      >
        <!-- TODO: fix regression . se si modifica l'header non viene più visualizzata l'icona dell'ordinamento -->
        <!--
        <template #head()="data">
          <slot name="header" :data="data">
            <BTh class="text-nowrap">
              {{ getLabel(data) }}
            </BTh>
          </slot>
        </template>
        -->
        <template #cell()="data">
          <!--<slot name="cell-pre" :data="data"></slot>-->
          <TableCell :item="data" @change="onCellChange" :row="getRow(data)"/>
          <!--<slot name="cell" :data="data"></slot>-->
        </template>
        <template #custom-foot="data" v-if="showFooter">
          <b-tr v-if="showTotal(getFields(data))">
            <b-th v-for="field in getFields(data)" :key="field.key" :class="showTotalCssClass(field)">
              <div class="help-text">
                <span v-if="field.showTotalHelpText">{{ field.showTotalHelpText() }}</span>
              </div>
              <span v-if="field.showTotal">
             {{ getTotal(field) }}
            </span>
            </b-th>
          </b-tr>
        </template>
      </b-table>
    </site-overlay>
    <b-row>
      <b-col cols="6">
        <small v-if="footerNote">{{ footerNote }}</small>
        <slot></slot>
      </b-col>
      <b-col cols="6">
        <b-row>
          <b-col v-if="totalRows && totalRows > 10">
            <b-form-select
                size="sm"
                v-model="perPage"
                :options="paginationOptions"
                @change="setPerPage"
            ></b-form-select>
          </b-col>
          <b-col cols="10" v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage ? perPage : totalRows"
                align="fill"
                size="sm"
                class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script src="./TabellaArticoli.ts" lang="ts"/>
<style src="./TabellaArticoli.scss" lang="scss"/>
